import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Form from "../common/form";
import WhyAcko from "../common/whyAcko";
import { useDispatch } from "react-redux";
import { useGetPartner } from "../common/customHooks";
import { landingPageLoaded } from "@analytics/bike/actions/landing";
import config from "../common/partnerConfig";
import Disclaimer from "../common/disclaimer";
import BikeBanner from "../bike/Banner";
import Header from "@components/partnerLPs/common/header";
import ExistingPolicyModal from "./ExistingPolicyAccessModal";
import { clearExistingPolicyData } from "@store/bikeProposalData/actions";
import { AnimatedLoader } from "@acko-tech/building-blocks.ui.loaders";
import { viewLandingPage } from "segments/eventActions/car/landingModule";
import { isEmpty } from "@utils/lodash";
import { useContext } from "react";
import Context from "@components/useContext/context";
import {
  resetVehicleMismatch,
  resetIllogicalFLowData
} from "@store/moData/proposalData/actions";
import {
  IllogicalModal,
  VehicleMismatchModal
} from "@acko-tech/building-blocks.ui.auto-modal-widgets";
import { updateProposalData } from "@store/moData/proposalData/actions";

const Widget = ({ data }) => {
  const dispatch = useDispatch();
  const partner = useGetPartner();
  const [showLoader, setShowLoader] = useState(true);
  const { isDesktop } = useContext(Context);
  const {
    isUserLoggedIn,
    isExistingPolicy,
    lastDigits,
    bikeNumber
  } = useSelector(({ bikeProposalDataReducer }: any) => ({
    isUserLoggedIn: bikeProposalDataReducer?.isUserLoggedIn,
    lastDigits: bikeProposalDataReducer?.lastDigits,
    bikeNumber: bikeProposalDataReducer?.bikeNumber,
    isExistingPolicy: bikeProposalDataReducer?.isExistingPolicy
  }));

  useEffect(() => {
    dispatch(landingPageLoaded());
    dispatch(viewLandingPage({}));
  }, []);

  function onCloseExistingPolicyModal() {
    dispatch(clearExistingPolicyData());
  }

  const createCarProposal = regNo => {
    dispatch(
      updateProposalData({
        data: {
          registration_number: regNo
        },
        origin: "acko",
        product: "car",
        sendRequest: true,
        callback: () => {
          dispatch(resetVehicleMismatch({}));
          // setting window product to freshCar, as we don't change it during client side redirection
          window.product = "freshCar";
        }
      })
    );
  };

  const PartnerLogo = config[partner]["bike"].partnerLogo;
  const { illogicalFlowData, vehicleMismatchData } = useSelector(
    ({ proposalDataReducer }: any) => ({
      illogicalFlowData: proposalDataReducer?.illogicalFlowData || {},
      vehicleMismatchData: proposalDataReducer?.vehicleMismatchData
    })
  );
  // hide loader for illogical flow handling
  useEffect(() => {
    if (!isEmpty(illogicalFlowData) || !isEmpty(vehicleMismatchData)) {
      setShowLoader(false);
    }
  }, [illogicalFlowData, vehicleMismatchData]);
  return (
    <>
      {showLoader && <AnimatedLoader />}
      <div className="container">
        <Header>
          {PartnerLogo && <PartnerLogo style={{ maxWidth: "90px" }} />}
        </Header>
        <BikeBanner />
        <WhyAcko />
        <Form
          setShowLoader={setShowLoader}
          isIllogicalFlow={isExistingPolicy}
          data={data}
        ></Form>
        <div className="divider"></div>
        <Disclaimer />
        <ExistingPolicyModal
          show={isExistingPolicy}
          isLoggedIn={isUserLoggedIn}
          onClose={onCloseExistingPolicyModal}
          isDesktop={false}
          lastDigits={lastDigits}
          bikeNumber={bikeNumber}
        />
        {!isEmpty(vehicleMismatchData) && (
          <VehicleMismatchModal
            isDesktop={isDesktop}
            show={!isEmpty(vehicleMismatchData)}
            onclose={() => {
              dispatch(resetVehicleMismatch({}));
            }}
            primaryCTAHandler={() => {
              dispatch(resetVehicleMismatch({}));
            }}
            secondaryCTAHandler={() => {
              createCarProposal(vehicleMismatchData.registrationNumber);
            }}
            identifiedVehicleType={vehicleMismatchData.context}
            registrationNumber={vehicleMismatchData.registrationNumber}
            product="bike"
          ></VehicleMismatchModal>
        )}
        {!isEmpty(illogicalFlowData) && (
          <IllogicalModal
            isDesktop={isDesktop}
            errorCode={illogicalFlowData.error_code}
            onclose={() => dispatch(resetIllogicalFLowData())}
            show={!isEmpty(illogicalFlowData)}
            illogicalFlowData={illogicalFlowData}
            secondaryCTAHandler={() => {}}
            product="bike"
          ></IllogicalModal>
        )}
        <style jsx>{`
          .container {
            max-width: 440px;
            margin: 0 auto;
            background: white;
          }
          .divider {
            margin: 32px 15px 0px 15px;
            border: 1px solid #e4eaf1;
          }
        `}</style>
      </div>
    </>
  );
};

export default Widget;
